import type { Store } from 'effector'

import { api } from '@setplex/tria-api'
import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'
import { ssePurchasesModel } from '~/features/payment/sse-purchases'
import { formatVodBundleInfoToUi } from './lib'

export const $vodBundlesRowFormatted = combine(
  api.vodBundles.$vodBundlesRow,
  ssePurchasesModel.$vodSet,
  i18n.$t,
  (vodBundles, adjust, { t }) =>
    vodBundles.map(formatVodBundleInfoToUi(t, adjust))
)

export const $vodBundlesRowTitle: Store<string> = combine(i18n.$t, ({ t }) =>
  t('extras')
)
